<ion-header
  class="ion-no-border"
  [ngClass]="isTouch ? 'ion-header-modal-tablet' : 'ion-header-modal-desktop'"
>
  <ion-toolbar>
    <ion-buttons *ngIf="!isTouch" slot="end">
      <ion-button data-cy="close-modal-btn" (click)="dismiss()">
        <ion-icon slot="icon-only" name="close-outline"></ion-icon>
      </ion-button>
    </ion-buttons>
    <ion-label>{{ title }}</ion-label>
    <ion-badge>{{ totalFilters }}</ion-badge>
  </ion-toolbar>
</ion-header>
<ion-content class="filtering-modal-content" scroll-y="false">
  <div class="content-container">
    <ion-list class="filters content-column">
      <ion-list>
        <ion-item
          *ngIf="isTouch && !disableSort"
          [attr.data-cy]="'filter-item-sort-by'"
          [ngClass]="{ selected: selectedFilterIndex === -1 }"
          (click)="showSortByComponent()"
          detail
        >
          <ion-label>{{ 'i18n.common.sortBy' | translate }}</ion-label>
        </ion-item>
      </ion-list>

      <ion-item
        *ngIf="isTouch && !isBusinessAnalytics"
        class="filter-list-title"
      >
        <ion-label>{{ 'i18n.common.filterBy' | translate }}</ion-label>
      </ion-item>

      <ion-item
        *ngFor="let filter of filters; index as index"
        [attr.data-cy]="'filter-item-' + filter.filterName"
        detail
        [ngClass]="{ selected: index === selectedFilterIndex }"
        (click)="selectFilter(index)"
      >
        <ion-label>
          {{ filter.data.title }}
          <span *ngIf="!!(filter.data.subTitle$ | async)">
            {{ filter.data.subTitle$ | async }}
          </span>
        </ion-label>
      </ion-item>
    </ion-list>

    <div class="content-column filter-value-selector">
      <ng-template appFilterOptionHost></ng-template>
    </div>
  </div>
</ion-content>
<ion-footer class="ion-footer-modal">
  <ion-toolbar>
    <ion-buttons>
      <ion-button
        *ngIf="!cancelButton"
        data-cy="clear-all-modal-btn"
        class="usf-outline-green-button"
        (click)="clearFilters()"
      >
        {{ 'i18n.common.clearAll' | translate }}
      </ion-button>
      <ion-button
        *ngIf="cancelButton"
        data-cy="clear-all-modal-btn"
        class="usf-outline-green-button"
        (click)="dismiss()"
      >
        {{ 'i18n.common.cancel' | translate }}
      </ion-button>
      <ion-button
        [disabled]="disableApplyFiltersButton"
        data-cy="apply-modal-btn"
        class="usf-fill-green-button"
        (click)="applyFilters()"
      >
        {{ 'i18n.common.apply' | translate }}
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-footer>
